import { render } from "./iconModal.vue?vue&type=template&id=37a8b510&scoped=true"
import script from "./iconModal.vue?vue&type=script&lang=js"
export * from "./iconModal.vue?vue&type=script&lang=js"

import "./iconModal.vue?vue&type=style&index=0&id=37a8b510&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a8b510"]])

export default __exports__